import { Typography } from "@material-ui/core";
import styled from "styled-components";

const blue = (props) => props.theme.palette.blue;

const opensans = (props) => props.theme.fonts.opensans;

export const TypographyStyled = styled(Typography)`
  font-weight: bold !important;
  font-size: 18px !important;
  color: ${blue};
  font-family: ${opensans} !important;
`;
